import React, { useState } from 'react';
import styles from './profileCard.module.scss';
import { Button, Card } from 'antd';
import { useAuth } from '../../context/useAuth';
import UserDetailsModal from '../../features/users/components/modals/UserDetailsModal';
import PropTypes from 'prop-types';
import { formatUsername } from '../../shared/utils/roles';

const ProfileCard = ({ onOpenModal }) => {
  const { user, logout } = useAuth();
  const [isUserDetailsModalOpen, setIsUserDetailsModalOpen] = useState(false);

  const handleOpenUserDetails = () => {
    if (onOpenModal) onOpenModal();
    setTimeout(() => setIsUserDetailsModalOpen(true), 100);
  };

  const handleCloseUserDetails = () => {
    setIsUserDetailsModalOpen(false);
  };

  return (
    <div className={styles.profileCardContainer}>
      <Card className={styles.profileCard}>
        <div className={styles.profileCard__profileDetails}>
          <div
            style={{
              padding: user?.profileImage ? '0' : '8px',
            }}
            className={styles.profileCard__profileDetails__imageContainer}
          >
            <img
              src={user?.profileImage || '/assets/icons/user.svg'}
              alt="user_icon"
            />
          </div>
          <div>
            <span className={styles.profileCard__profileDetails__name}>
              {/* Firme prikazuju responsibleName; sve ostalo (individual +
                  staff/admin nalozi, koji mozda nemaju `type`) -> ime i prezime. */}
              {user?.type === 'company' ? (
                <>{user.responsibleName}</>
              ) : (
                <>
                  {user?.firstName} {user?.lastName}
                </>
              )}
            </span>
            <br />
            {/* Admin nalozi nemaju email, prikazuje se @ime.prezime. */}
            <span className={styles.profileCard__profileDetails__email}>
              {user.username ? formatUsername(user.username) : user.email}
            </span>
          </div>
        </div>

        <div className={styles.profileCard__optionsContainer}>
          <span className={styles.profileCard__profileDetails__email}>
            Opcije
          </span>
          <div
            className={styles.profileCard__optionsContainer__buttonContainer}
          >
            <Button type="default" onClick={handleOpenUserDetails}>
              Pogledaj nalog
            </Button>
            <Button
              className={styles.profileCard__optionsContainer__logoutButton}
              onClick={() => logout()}
            >
              Odjavi se
            </Button>
          </div>
        </div>
      </Card>

      <UserDetailsModal
        isOpen={isUserDetailsModalOpen}
        onClose={handleCloseUserDetails}
      />
    </div>
  );
};

ProfileCard.propTypes = {
  onOpenModal: PropTypes.func.isRequired,
};

export default ProfileCard;
